import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from '../component/Header'
import Footer from '../component/Footer'
import HomeRealEstateAgentForm from '../component/HomeRealEstateAgentForm'
import ExploreResultLocations from '../component/ExploreResultLocations'
import RecommendedYou from '../component/RecommendedYou'
import ProductCommercialView from '../component/ProductCommercialView'
import ProductCommercialDetails from '../component/ProductCommercialDetails'
import { GET_PROPERTY_BY_ID } from '../api/constants'
import { useProperty } from "../hooks/useProperty";

function CommercialDetails() {
  const { property, loading } = useProperty();


  if (loading) return <div>Loading...</div>;
  if (!property) return <div>Property not found</div>;
  return (
    <>
      <div className='main product-details'>
        <Header />
        <ProductCommercialView property={property} />
        <ProductCommercialDetails property={property} />
        <HomeRealEstateAgentForm property={property} />
        <RecommendedYou />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default CommercialDetails


